/* eslint-disable no-nested-ternary */
import { getPreference, setPreference } from '@fs/zion-preferences'
/**
 * Set data on the user's preference service to update the last search stats
 * @param {string} taskType - 'Name Correction', 'Name Review' or 'Family Review'
 * @returns {Promise<void>}
 */
const updateLastSearchStats = async (taskType) => {
  // eslint-disable-next-line no-nested-ternary
  const type = taskType === 'Full Name Review' ? 'full' : taskType === 'Family Review' ? 'family' : 'quick'
  const preferenceKey = `give.${type}_lastSearch`
  try {
    const data = await getPreference(preferenceKey)
    if (data) {
      await setPreference(preferenceKey, { ...data, stats: +data.stats + 1 })
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(`error updating ${preferenceKey} stats`, error)
  }
}

export default updateLastSearchStats
